import React, { useEffect, useState } from "react";
import { CardVote } from "./components/CardVote";
import { Footer } from "./components/Footer";
import { Hero } from "./components/Hero";
import { QuestionInput } from "./components/QuestionInput";
import "./App.scss";
import { QuestionInputModal } from "./components/QuestionInputModal";
import { useQuestionStore } from "./stores/QuestionStore";

/* 
To deploy the WebApp, run following Commands: 
  1. npm run build
  2. firebase deploy
*/

function App() {
  const questionStore = useQuestionStore();
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    questionStore.setFavoriteQuestions();
  }, []);

  return (
    <>
      <Hero />
      <div className="App">
        <div className="container is-fluid">
          <CardVote />
          <QuestionInput setModalOpen={setModalOpen} />
        </div>
      </div>
      <Footer />
      {modalOpen && <QuestionInputModal setModalOpen={setModalOpen} />}
    </>
  );
}

export default App;
